import { Component } from 'react';
import Button from 'react-bootstrap/lib/Button';
import PropTypes from 'prop-types';
import mapProps from 'map-props';

import ChevronRightIcon from 'components/icons/ChevronRightIcon.com.svg';

import Item from './Item';
import EquipmentsItem from './items/EquipmentsItem';
import FuelItem from './items/FuelItem';
import LocationItem from './items/LocationItem';
import TransmissionItem from './items/TransmissionItem';
import MakeModelSubType from './items/MakeModelSubTypeItem';
import PriceItem from './items/PriceItem';
import MileageItem from './items/MileageItem';
import YearItem from './items/YearItem';

import propsMapping from './propsMapping';
import cn from './styles.local.less';

class CollapseFilters extends Component {
  static propTypes = {
    formName: PropTypes.string.isRequired,
    initialOpened: PropTypes.object.isRequired,
    onExtraFiltersOpen: PropTypes.func.isRequired,
    onFiltersChanged: PropTypes.func.isRequired,
    withEquipments: PropTypes.bool,
    withExtraFilters: PropTypes.bool,
  };

  render() {
    const {
      formName,
      initialOpened,
      onExtraFiltersOpen,
      onFiltersChanged,
      withEquipments,
      withExtraFilters,
    } = this.props;

    return (
      <div data-qa-selector="sidebar-filters">
        <Item
          Body={MakeModelSubType}
          formName={formName}
          initialOpened={initialOpened.makes}
          label={__('search.filters.makes')}
          onChanged={onFiltersChanged}
          qaSelector="filter-make-model"
        />
        <Item
          initialOpened={initialOpened.price || initialOpened.monthlyPrice}
          label={__('search.filters.priceOptions')}
          Body={PriceItem}
          onChanged={onFiltersChanged}
          qaSelector="filter-price"
          formName={formName}
        />
        <Item
          Body={YearItem}
          initialOpened={initialOpened.year}
          label={__('search.filters.year')}
          onChanged={onFiltersChanged}
          qaSelector="filter-year"
        />
        <Item
          Body={MileageItem}
          initialOpened={initialOpened.mileage}
          label={__('search.filters.mileage')}
          onChanged={onFiltersChanged}
          qaSelector="filter-mileage"
        />
        <Item
          Body={LocationItem}
          formName={formName}
          initialOpened={initialOpened.location}
          label={__('search.filters.location')}
          onChanged={onFiltersChanged}
          qaSelector="filter-location"
          modalTitle={__('search.filters.distance')}
        />
        <Item
          Body={FuelItem}
          initialOpened={initialOpened.fuelType}
          label={__('search.filters.fuelType')}
          onChanged={onFiltersChanged}
          qaSelector="filter-fuelType"
          modalTitle={__('search.filters.fuelType')}
        />
        <Item
          Body={TransmissionItem}
          initialOpened={initialOpened.transmission}
          label={__('search.filters.transmission')}
          onChanged={onFiltersChanged}
          qaSelector="filter-transmission"
          modalTitle={__('search.filters.transmission')}
        />

        {withEquipments ? (
          <Item
            Body={EquipmentsItem}
            initialOpened={initialOpened.equipments}
            label={__('search.filters.equipments')}
            onChanged={onFiltersChanged}
            qaSelector="filter-equipments"
          />
        ) : null}

        {withExtraFilters ? (
          <Button
            block
            bsStyle="link"
            className={cn.advBtn}
            onClick={onExtraFiltersOpen}
          >
            <span className={cn.advBtnText}>{__('search.advBtnTitle')}</span>
            <ChevronRightIcon className={cn.advBtnIcon} />
          </Button>
        ) : null}
      </div>
    );
  }
}

export default mapProps(propsMapping)(CollapseFilters);
